/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../sass/app.scss';
// axios/CSRF 같은 framework bootstrap 만 유지한다.
// Font Awesome icons and jQuery legacy bridge are split into separate entries.
import './bootstrap';
import './iife-pages/public-content-inline-editor.js';
import './iife-pages/home-page-setting-card-save.js';
// import datatable from 'datatables';
// require('datatables.net');

var appPageModulesStarted = false;

function bootAppPageModules() {
    if (appPageModulesStarted) return;
    appPageModulesStarted = true;

    var fetchRef = window.fetch && window.fetch.bind(window);
    if (typeof window.SkmPublicContentEditor === 'function') {
        window.SkmPublicContentEditor({
            document: window.document,
            window,
            fetch: fetchRef,
        }).init();
    }
    if (typeof window.SkmHomePageSettingCardSave === 'function') {
        window.SkmHomePageSettingCardSave({
            document: window.document,
            window,
            fetch: fetchRef,
            FormData: window.FormData,
        }).init();
    }
}

if (window.document.readyState === 'loading') {
    window.document.addEventListener('DOMContentLoaded', bootAppPageModules, { once: true });
} else {
    bootAppPageModules();
}


/*
 * Vue 2 scaffolding 은 Laravel 5.5 시대 잔재로, 본 코드베이스는 Vue 사용처 0건.
 * Vue 2 + vue-template-compiler dependency 와 함께 ExampleComponent.vue 도 제거됨.
 * (PR-B, 2026-05-13 — Laravel 13 정리 시리즈)
 */
